import { Action, createReducer, on } from '@ngrx/store';
import { changeUserType } from './../actions/toolbar.actions';

const userTypeStored = JSON.parse(localStorage.getItem('userType')!);
const initialState: any = {
  userType: 'C'
};

const toolbarReducer = createReducer(
  userTypeStored || initialState,
  on(changeUserType, (state, props) => ({ 
    ...state, 
    userType: props.userType
  })),
);

export function ToolbarReducer(state: boolean | undefined, action: Action) {
  return toolbarReducer(state, action);
}
